import Header from '../Components/Header';
import Footer from '../Components/Footer';
import Sector from '../Components/Sector';
import Text from '../Components/Text';

import {
    useState
} from 'react';
import {
    useNavigate,
    useLocation
} from "react-router-dom";
import Radio from '../Components/Radio';
import {
    useGlobalState
} from '../Networks/QuestionState';

const QuestionPage6 = () => {
    const [sample] = useGlobalState('sample');
    console.log('sample 6 :>> ', sample);

    let location = useLocation();

    let [ans23, setAns23] = useState([]);

    // let Page2Answers = {
    //   ans23
    // }
    // console.log('Question Page6',Page2Answers)
    // console.log('GcsiPageAnswers',location.state.GcsiPageAnswers)

    // Error states for each question: false - no error and true - error present
    let [error23, setError23] = useState();

    const data = sample
    let question
    question = data.map((data) => {
        // let selected_company = 'ABSA BANK';//SECTOR FROM SESSION FROM PREVIOUS PAGE'ANSWER
        let id = data.id;

        console.log("REEEEED: "+id);

        if (id === 23) {
            let question = data.question
            let answers = data.answers
            return <Text
            onValueChange = {
                setAns23
            }
            errorState = {
                error23
            }
            onBlur={(e) => {
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                const enteredEmail = e.target.value;

                setError23(!emailPattern.test(enteredEmail) && enteredEmail.length > 0);
                }}
            question = {
                question
            }
            answers = {
                answers
            }
            sameName = {
                id
            }
            key = {
                    id
                } >
                <
                /Text>
        } else {
            // console.log('data else:>> NAN');
            return null;
        }
    });


    // error handling click event
    const onTapped = () => {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const enteredEmail = ans23.value;

  if (ans23.length !== 0 && emailPattern.test(enteredEmail)) {
    let GcsiPageAnswers = {
      ...location.state.GcsiPageAnswers,
      q23: enteredEmail,
    };

    console.log('6. GcsiPageAnswers', GcsiPageAnswers);
    navigate('/survey/question7', {
      state: {
        GcsiPageAnswers,
      },
    });
  } else if(ans23.length === 0) {
    let GcsiPageAnswers = {
      ...location.state.GcsiPageAnswers,
      q23: enteredEmail,
    };

    console.log('6. GcsiPageAnswers', GcsiPageAnswers);
    navigate('/survey/question7', {
      state: {
        GcsiPageAnswers,
      },
    });
  } else {
    setError23(true);
  }
};


    const sector_title = `SURVEY REPORT REQUEST`
    const navigate = useNavigate();
    return ( <
        div className = "main-body" >
        <
        Header key = {
            'header'
        } > < /Header> <
        Sector sector_title = {
            sector_title
        }
        key = {
            'sector'
        } > < /Sector> {
            question
        }

        <
        Footer key = {
            'footer'
        }
        title = {
            ans23.length === 0? 'Skip' : 'Next'
        }
        onTap = {
            () => {
                onTapped()
            }
        }
        button_state = 'true'
        load = {
            '84%'
        }
        page = {
            7
        } > < /Footer> <
        /div>
    );
}

export default QuestionPage6;